const truncUnitCounter = (value, returnFloat) => {
    const truncatedNumber = (Math.round(value * 100) / 100).toFixed(2);
    if (returnFloat) return parseFloat(truncatedNumber);
    return truncatedNumber;
};

export default truncUnitCounter;
